<template>
  <portal to="modals">
    <div class="confirm fixed inset-0 z-50 flex items-center justify-center">
      <div class="w-96 bg-white p-8 rounded-md shadow-xl overflow-y-hidden max-h-3/4 flex flex-col">
        
        <div 
          class="text-xl font-semibold flex-0" 
          v-html="title"
        ></div>

        <div class="mt-4 flex-1 overflow-y-auto">
          <slot />
        </div>

        <slot name="buttons">
          <div class="mt-8 flex justify-between">
            
            <PButton 
              class="w-32" 
              color="primary"
              @click="$emit('accept')" 
              v-html="acceptButtonText"
            ></PButton>

            <PButton 
              class="w-32" 
              color="danger"
              @click="$emit('reject')" 
              v-html="rejectButtonText"
            ></PButton>

          </div>
        </slot>

      </div>
    </div>
</portal>
</template>

<script>
export default {
  
  name: "p-confirm",
  
  props: {

    title: {
      type: String,
      default: ""
    },

    acceptButtonText: {
      type: String,
      default () {
        return this.$tk("Common.General.Yes")
      }
    },

    rejectButtonText: {
      type: String,
      default () {
        return this.$tk("Common.General.No")
      }
    },

    type: {
      type: String,
      default: "",
      validator: function (value) {
        return [
          "", 
          "warning", 
          "info", 
          "error"
        ].indexOf((value ?? "").toLowerCase()) !== -1;
      },
    }

  }
  
}
</script>

<style>
  .confirm { background-color: rgba(0,0,0,.5)}
</style>